// extracted by mini-css-extract-plugin
export default {"wrapper":"select-page_wrapper__uFtrS"};